/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateLeadCommentTaskWorkflowItemRequest
 */
export interface UpdateLeadCommentTaskWorkflowItemRequest {
    /**
     * Null removes the tag.
     */
    lead_task_workflow_item_id: string | null;
}

/**
 * Check if a given object implements the UpdateLeadCommentTaskWorkflowItemRequest interface.
 */
export function instanceOfUpdateLeadCommentTaskWorkflowItemRequest(value: object): value is UpdateLeadCommentTaskWorkflowItemRequest {
    if (!('lead_task_workflow_item_id' in value) || value['lead_task_workflow_item_id'] === undefined) return false;
    return true;
}

export function UpdateLeadCommentTaskWorkflowItemRequestFromJSON(json: any): UpdateLeadCommentTaskWorkflowItemRequest {
    return UpdateLeadCommentTaskWorkflowItemRequestFromJSONTyped(json, false);
}

export function UpdateLeadCommentTaskWorkflowItemRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateLeadCommentTaskWorkflowItemRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'lead_task_workflow_item_id': json['lead_task_workflow_item_id'],
    };
}

export function UpdateLeadCommentTaskWorkflowItemRequestToJSON(json: any): UpdateLeadCommentTaskWorkflowItemRequest {
    return UpdateLeadCommentTaskWorkflowItemRequestToJSONTyped(json, false);
}

export function UpdateLeadCommentTaskWorkflowItemRequestToJSONTyped(value?: UpdateLeadCommentTaskWorkflowItemRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'lead_task_workflow_item_id': value['lead_task_workflow_item_id'],
    };
}

